import supabase from "./supabase";
import { FunctionsHttpError } from "@supabase/supabase-js";

export interface RawTeacher {
  id: string;
  fullname: string;
  firstname: string;
  lastname: string;
  district: string;
  email: string;
  role: string;
  school: string;
  created_at: string;
  schoolName: string;
}

export interface GetTeachersParams {
  search?: string;
}

export async function getTeachers(params?: GetTeachersParams): Promise<{
  data: RawTeacher[] | null;
  error: string | null;
}> {
  const { error, data } = await supabase.functions.invoke("getTeachers", {
    body: params,
  });

  if (error) {
    if (error instanceof FunctionsHttpError) {
      const errorMessage = await error.context.json();
      return { error: errorMessage.error, data: null };
    } else {
      return { error: error?.message || null, data: null };
    }
  }

  return { data: data?.teachers ?? null, error: null };
}
